import {
  bgTokens,
  borderTokens,
  iconTokens,
  textTokens,
  UNSAFE_colors,
} from '@mindtickle/styles/lib';
import { NavigationColorType } from './types';

export const navigationDefaultColors: NavigationColorType = {
  navContainerBgColor: bgTokens.COLOR_BG_DEFAULT,
  navContainerBorderColor: borderTokens.COLOR_BORDER_SECONDARY,

  toggleBtnIconColor: iconTokens.COLOR_ICON_SECONDARY,
  toggleBtnIconHoverColor: iconTokens.COLOR_ICON_DEFAULT,
  toggleBtnBgColor: bgTokens.COLOR_BG_DEFAULT,
  toggleBtnBgHoverColor: bgTokens.COLOR_BG_TERTIARY,
  toggleBtnIconActiveColor: iconTokens.COLOR_ICON_ACCENT,

  navMenuBgColor: bgTokens.COLOR_BG_DEFAULT,
  navMenuBgHoverColor: bgTokens.COLOR_BG_TERTIARY,

  navMenuNameColor: textTokens.COLOR_TEXT_SECONDARY,
  navMenuNameActiveColor: textTokens.COLOR_TEXT_DEFAULT,
  navMenuIconColor: iconTokens.COLOR_ICON_DEFAULT,
  navMenuIconActiveColor: iconTokens.COLOR_ICON_ACCENT,

  navRouteBgColor: bgTokens.COLOR_BG_DEFAULT,
  navRouteBgHoverColor: bgTokens.COLOR_BG_TERTIARY,
  navRouteBgActiveColor: bgTokens.COLOR_BG_ACCENT_SUBTLE,
  navRouteNameColor: textTokens.COLOR_TEXT_SECONDARY,
  navRouteNameHoverColor: textTokens.COLOR_TEXT_DEFAULT,
  navRouteNameActiveColor: textTokens.COLOR_TEXT_DEFAULT,

  navCopilotBgColor: UNSAFE_colors.AEROSPACE_ORANGE,
  navCopilotIconColor: UNSAFE_colors.WHITE,
};
